export default __webpack_public_path__ + "static/media/DownloadIcon.99d55e74.svg";